<template>
  <div
    ref="dropMenu"
    class="drop-down-component"
  >
    <!-- 按钮 -->
    <div
      ref="dropButton"
      :class="['btn-wraper', list.length <= 1 ? 'disabled':'']"
      @click="dropDown"
    >
      <slot name="btname">
        {{ name }}
      </slot>
      <!-- 图标 -->
      <slot name="icon">
        <span
          class="icon-wrapper"
          :style="{paddingLeft:pleft}"
        >
          <svg
            :class="['item-icon', (isShowMenu ? 'item-icon-rotate' : '')]"
            :style="{verticalAlign:align}"
          >
            <use :xlink:href="iconName" />
          </svg>
        </span>
      </slot>
    </div>

    <!-- 弹出列表 -->
    <div
      v-show="isShowMenu"
      ref="dropList"
      class="drop-down-list-up"
      :style="{width:`${menuWidth}px`}"
    >
      <slot name="drop-down-slot-ul">
        <ul
          ref="dropUl"
          class="drop-down-list-ul"
        >
          <li
            v-for="(val,index) in list"
            :key="val[keyName]"
            :class="[curKey == val[keyName] ?'dorp-down-list-li-active':'','dorp-down-list-li']"
            @click="theEvent(val)"
          >
            <slot
              name="name"
              :data="{data:val,index:index}"
            >
              <span>{{ $t(val.name) }}</span>
            </slot>
          </li>
        </ul>
      </slot>
    </div>
  </div>
</template>
<script>
/*
 * @Author: lisiy
 * @Date: 2019-12-10 15:22
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-12-31 18:29:48
 */
import { getWidthOrHeight } from 'js/util/util.js'

export default {
  props: {
    keyName: {
      type: String,
      default: 'key',
    },
    valName: {
      type: String,
      default: 'name',
    },
    value: '',
    // 列表
    list: {
      type: Array,
      default() {
        return []
      },
    },
    // 列表只想上弹出状态位
    onlyUp: {
      type: Boolean,
      default: false,
    },
    // 是否右对齐
    isRight: {
      type: Boolean,
      default: false,
    },
    // 是否左对齐
    isLeft: {
      type: Boolean,
      default: false,
    },
    // 列表按钮间距
    distance: {
      type: Number,
      default: 4,

    },
    // 图标名字
    iconName: {
      type: String,
      default: '#arr-up',
    },
    // 文件数量
    fileCount: {
      type: Array,
      default() {
        return []
      },
    },
    menuWidth: {
      type: [String, Number],
      default: '160',
    },
    pleft: { // 控制icon离文字的距离
      type: String,
      default: '6px',
    },
    align: { // 控制icon垂直的位置
      type: String,
      default: 'middle',
    },
  },
  data() {
    return {
      isShowMenu: false, // 列表显隐状态位
      name: '',
      curKey: '',
    }
  },
  watch: {
    curKey(n, o) {
      this.init()
      this.$emit('input', n)
    },
    value(n, o) {
      this.curKey = n
    },
    /**
         * 当下拉菜单展开时注册全局的click事件
         * 当下拉菜单收起时取消全局的click事件
         */
    isShowMenu(n) {
      const iframe = document.getElementById('pdfframe')
      if (n) {
        document.addEventListener('click', this.otherClick)
        // 可传一个函数来注册iframe的点击事件
        // 目前预览页面会有一个iframe所以加到组件里
        if (iframe && iframe.contentDocument) {
          iframe.contentDocument.addEventListener('click', this.otherClick)
        }
        return
      }
      document.removeEventListener('click', this.otherClick)
      if (iframe && iframe.contentDocument) {
        iframe.contentDocument.removeEventListener('click', this.otherClick)
      }
    },

  },
  created() {
    this.curKey = this.value
    this.init()
  },
  methods: {
    init() {
      const me = this
      this.list.map((it) => {
        if (it[me.keyName] == me.curKey) {
          me.name = it[me.valName] || ''
        }
      })
    },
    /**
         * 点击空白区域
         */
    otherClick(e) {
      const menuC = this.$refs.dropMenu
      if (menuC.contains(e.target)) {
        return
      }
      this.isShowMenu = false
    },
    /**
             * 展开下拉菜单
             * 控制菜单的显示隐藏
             */
    dropDown(e) { // 点击列表事件
      if (this.list.length <= 1) return // 列表只有一个时，不显示上拉
      this.isShowMenu = !this.isShowMenu // toggle
      if (this.isShowMenu) {
        this.locateMen(e)
      }
    },
    /**
             * 定位下拉框位置
             */
    locateMen(e) { // 蒙板
      this.$nextTick(function () {
        const list = this.$refs.dropMenu
        const btn = this.$refs.dropButton
        const rect = btn.getBoundingClientRect()
        // 获取浏览器的宽度
        const winWith = window.innerWidth
        const winHeight = window.innerHeight
        // 获取菜单的宽度 高度
        const menu = this.$refs.dropList
        const menuW = getWidthOrHeight(menu, 'width')
        const menuH = getWidthOrHeight(menu, 'height')

        // 当设置只向上弹出
        if (this.onlyUp) {
          menu.style.top = `-${menuH}px`
        } else {
          menu.style.right = '0px'
          // 如果下方距离不够则向上弹出
          if ((winHeight - rect.bottom) < menuH) {
            menu.style.top = ''
            menu.style.bottom = `${winHeight - rect.top + this.distance}px`
          } else {
            // 否则向下弹出
            menu.style.bottom = ''
            menu.style.top = `${(list.offsetHeight - btn.offsetHeight) / 2 + btn.offsetHeight + this.distance}px`
          }
        }
        // 右对齐
        if (this.isRight && !this.isLeft) {
          menu.style.right = '0px' // 右对齐
        } else if (this.isLeft && !this.isRight) {
          // 左对齐
          menu.style.left = '0px' // 左对齐
        } else {
          // 如果不设置左右右对齐

          // 如果右侧距离不右对齐
          if ((winWith - rect.right) < menuW) {
            menu.style.right = '0px'
          } else {
            menu.style.left = '0px' // 否则左对齐
          }
        }
      })
    },
    /**
             * 点击当前菜单
             */
    theEvent(val) {
      this.name = val.name || ''
      this.curKey = val[this.keyName]
      this.$emit('click-item', val)
      this.isShowMenu = false
    },
  },
}
</script>
<style scoped lang="less">
.btn-wraper{
  height: 32px;
  line-height: 32px;
  display: inline-block;
  text-align: center;
  border-radius: 2px;
  padding: 0 8px;
}
.btn-wraper:hover{
  background: #E8EBEF;
}
.btn-wraper:active{
  background: #C1C7CD;
}
.disabled{ // 不可操作状态
  color: #929CA9;
  &:hover{
    background: none;
    color: #929CA9;
  }
  &:active{
    background: none;
    color: #929CA9;
  }
}
.isselected{
  background: #E8EBEF;
}
.drop-down-component {
  display: inline-block;
  position: relative;
  margin-right: 12px;
}
.scroll{   //滚动条
  overflow-x: hidden;
  overflow-y: auto;
}
.drop-down-button {    //按钮
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
  display: block;
  margin: auto;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #C1C7CD;
  font-size: 14px;
  color: #1B2733;
  background: #FFFFFF;
  user-select: none;    //无法选中文字部分
}

.drop-down-list-up {     //弹出列表
  box-shadow: 0 4px 14px 0 rgba(5, 15, 40, .1);
  background: #fff;
  border-radius: 2px;
  border: 1px solid #e8ebef;
  width: 160px;
  position:absolute;
  padding: 8px 0;

}

.drop-down-list-ul::-webkit-scrollbar {  //滚动条样式
  width: 4px;

}

.drop-down-list-ul::-webkit-scrollbar-thumb {
  background: rgb(194, 199, 205);
  border-radius: 5px;
}
.dorp-down-list-li {
  line-height: 36px;
  padding: 0 26px;
  color: #282e3d;
}

.dorp-down-list-li:hover {   //li hover
  background-color: rgb(246, 247, 250);
}
.dorp-down-list-li-active {   //li hover
  background-color: rgb(246, 247, 250);
}
.icon-wrapper{
  padding: 0 0 0 6px;
}
.item-icon{
  width: 8px;
  height: 4px;
  display: inline-block;
  vertical-align: middle;
}
.item-icon-rotate{
  transform:rotate(180deg);
}
</style>
